import React, { useEffect, useState } from "react";
import "./Dashboard.css";

import TodaySales from "./TodaySales/TodaySales";
import SalesAnalysis from "./SalesAnalysis/SalesAnalysis";
import { useThemeContext } from "../../Context/ThemeContext";
import InventoryLevel from "./InventoryLevel/InventoryLevel";
import MachineStatus from "./MachineStatus/MachineStatus";
import Maintenance from "./Maintenance/Maintenance";
import Tax from "./Tax/Tax";
import Map from "./MapComponent/MapComponent";
import useAuth from "../../Hooks/useAuth";
import MachineBinLevel from "./MachineLevelBin/MachineLevelBin";
import { getFranchiseMachineType } from "../../Services/authService";

const DashboardPage = () => {
  const { mode } = useThemeContext();
  const { user } = useAuth();

  const [machineType, setMachineType] = useState(null);

  const franchiseId = Number(user?.franchiseId);
  const isFranchise22 = franchiseId === 22;

  useEffect(() => {
    const fetchMachineType = async () => {
      try {
        const response = await getFranchiseMachineType();

       

        setMachineType(response?.data?.machineType);
      } catch (error) {
        
      }
    };

    fetchMachineType();
  }, []);

 const isReturnFoodVending = machineType === "RETURN_AND_FOOD_VENDING";

const hasReturnMachine =
  machineType === "RETURN_ONLY" ||
  machineType === "BOTH" ||
  isReturnFoodVending;

const hasVendingMachine =
  machineType === "VENDING_ONLY" ||
  machineType === "BOTH" ||
  isReturnFoodVending;


const isBothMachineType =
  machineType === "BOTH" || isReturnFoodVending;

const effectiveMachineType = isReturnFoodVending ? "BOTH" : machineType;

  const containerBackground =
    mode === "dark"
      ? "#2D2D2D"
      : "#ffffff";

  // Wait until machine type is available
  if (!machineType) {
    return null;
  }

  return (
    <div className="dashboard-container-overview">

      {/* ================================================= */}
      {/* RETURN ONLY                                      */}
      {/* ================================================= */}

      {machineType === "RETURN_ONLY" && (
        <>
          {/* Today's Returns (via TodaySales) + Machine Status */}

          <div className="dashboard-container">

            <div
              className="containers-section-overall today-sales"
              style={{
                backgroundColor: containerBackground,
              }}
            >
              <TodaySales machineType={effectiveMachineType} />
            </div>

            <div
              className="containers-section-overall sales-analysis"
              style={{
                backgroundColor: containerBackground,
              }}
            >
              <MachineStatus />
            </div>

          </div>


          {/* Machine Bin Level */}

          <div className="dashboard-container machine-bin-level-row">

            <div
              className="containers-section-overall machine-bin-level-full"
              style={{
                backgroundColor: containerBackground,
              }}
            >
              <MachineBinLevel />
            </div>

          </div>
        </>
      )}


      {/* ================================================= */}
      {/* VENDING ONLY + BOTH                              */}
      {/* ================================================= */}

      {hasVendingMachine && (
        <>
          {/* Today's Sales + Sales Analysis */}

          {!user?.roles?.includes("ROLE_EMPLOYEE") && (
            <div className="dashboard-container">

              <div
                className="containers-section-overall today-sales"
                style={{
                  backgroundColor: containerBackground,
                }}
              >
               <TodaySales machineType={machineType} />
              </div>

              <div
                className="containers-section-overall sales-analysis"
                style={{
                  backgroundColor: containerBackground,
                }}
              >
                <SalesAnalysis />
              </div>

            </div>
          )}


          {/* Inventory Level + Machine Status */}

          <div className="dashboard-container">

            
              <div
                className="containers-section-overall today-sales"
                style={{
                  backgroundColor: containerBackground,
                }}
              >
              <InventoryLevel machineType={effectiveMachineType} />
              </div>
           

            <div
              className="containers-section-overall sales-analysis"
              style={{
                backgroundColor: containerBackground,
              }}
            >
              <MachineStatus />
            </div>

          </div>


          {/* Machine Bin Level - BOTH only */}

          {isBothMachineType && (
            <div className="dashboard-container machine-bin-level-row">

              <div
                className="containers-section-overall machine-bin-level-full"
                style={{
                  backgroundColor: containerBackground,
                }}
              >
                <MachineBinLevel />
              </div>

            </div>
          )}
        </>
      )}


      {/* ================================================= */}
      {/* MAP                                               */}
      {/* ================================================= */}

      <div className="dashboard-container">

        <div className="maps-container">
          <Map />
        </div>

      </div>

    </div>
  );
};

export default DashboardPage;